export default {
  form_edit_dialog: {
    title_create: `Contact Us`,
    button_create: 'Send',
  },
  alert: {
    created_successfully: 'The appeal has been sent',
  },
};
